import React from 'react';
import ModelVillage2025 from 'views/ModelVillage2025';


const MathClubPage = () => {
  return <ModelVillage2025/>;
};

export default MathClubPage;

